import React from "react"
import { Modal, Input, Row, Col, Typography } from "antd"
import { UserOutlined } from "@ant-design/icons"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"
import styles from "./index.module.css"

const { Title } = Typography

export const GuardianDetailsModal = ({ open, onCancel, record }) => {
  const guardian = record?.guardian_details || {}

  // The record itself is the minor participant in the GuestWaiverDetails context
  const minors = record?.full_name ? [{ full_name: record.full_name, birthdate: record.birthdate || record.date_of_birth }] : []

  return (
    <Modal
      maskClosable={false}
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={true}
      centered
      width={900}
      className={styles.modalContainer}
    >
      <div className="pb-xl">
        <div className="flex items-center gap-2">
          <UserOutlined style={{ fontSize: "20px" }} className="text-color-primary" />
          <Title level={3} className="text-lg font-bold">
            Guardian Details
          </Title>
        </div>
      </div>

      <Row gutter={16} className="mb-lg">
        <Col span={12}>
          <LabeledField labelKey="First Name*">
            <Input value={guardian.guardian_first_name || "-"} disabled />
          </LabeledField>
        </Col>
        <Col span={12}>
          <LabeledField labelKey="Last Name*">
            <Input value={guardian.guardian_last_name || "-"} disabled />
          </LabeledField>
        </Col>
      </Row>

      <Row gutter={16} className="mb-lg">
        <Col span={12}>
          <LabeledField labelKey="Email Address*">
            <Input value={guardian.guardian_email || "-"} disabled />
          </LabeledField>
        </Col>
        <Col span={12}>
          <LabeledField labelKey="Relation with minor(s)">
            <Input value={guardian.relation || "-"} disabled />
          </LabeledField>
        </Col>
      </Row>

      <Row gutter={16} className="mb-lg">
        <Col span={12}>
          <LabeledField labelKey="Phone Number*">
            <Input value={guardian.guardian_phone || "-"} disabled />
          </LabeledField>
        </Col>
      </Row>

      {minors.map((minor, idx) => (
        <React.Fragment key={idx}>
          <div className={`pb-xl ${styles.minorHeader}`}>{minors.length === 1 ? "Minor" : `Minor ${idx + 1}`}</div>
          <div className={styles.formRow}>
            <div className={styles.formCol}>
              <LabeledField labelKey="Minor Name*">
                <Input value={minor.full_name || "-"} disabled />
              </LabeledField>
            </div>
            <div className={styles.formCol}>
              <LabeledField labelKey="Date of Birth*">
                <Input value={minor.birthdate || minor.date_of_birth || "-"} disabled />
              </LabeledField>
            </div>
          </div>
        </React.Fragment>
      ))}

    </Modal>
  )
}
